import './App.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import 'react-quill/dist/quill.snow.css';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { BrandingController } from '@/components/Common/BrandingController';
import { useGetOrganizations } from 'apis/agency/organizations/hook';
import { HelmetProvider } from 'react-helmet-async';
import RootProvider from './providers/RootProvider';

function App() {
  return (
    <HelmetProvider>
      <RootProvider />
    </HelmetProvider>
  );
}

export default App;

export const ScrollToTop = ({ state }: { state?: number | null }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname, state]);
  return null;
};

export const OrganizationHeadUpdater = () => {
  const { data: organization } = useGetOrganizations();

  const [persistedTitle, setPersistedTitle] = useState<string | undefined>(organization?.name);
  const [persistedFavicon, setPersistedFavicon] = useState<string | undefined>(organization?.favicon_url);

  useEffect(() => {
    if (organization?.name) {
      setPersistedTitle(organization.name);
    }
    if (organization?.favicon_url) {
      setPersistedFavicon(organization.favicon_url);
    }
  }, [organization?.name, organization?.favicon_url]);

  const title = persistedTitle || organization?.name;
  const faviconUrl = persistedFavicon || organization?.favicon_url;

  return <BrandingController title={title} faviconUrl={faviconUrl} description={title} />;
};
